import React from "react";
import { useTranslation } from "react-i18next";
import Iconfont from "@components/iconfont/iconfont";

export default function H5LoginOptions({
  loginTextKey,
  loginIconType = "icon-yanzhengmadenglu",
  onLoginSwitch,
  onWechatLogin,
}) {
  const { t } = useTranslation();

  return (
    <div className="h5-login-options">
      <button
        type="button"
        className="h5-login-option"
        onClick={onLoginSwitch}
      >
        <Iconfont
          type={loginIconType}
          style={{ width: 24, height: 24 }}
          aria-hidden="true"
        />
        <span>{t(loginTextKey)}</span>
      </button>
      <span className="h5-login-options-divider" aria-hidden="true" />
      <button
        type="button"
        className="h5-login-option"
        onClick={onWechatLogin}
      >
        <Iconfont
          type="icon-a-weixintianchong"
          style={{ width: 24, height: 24 }}
          aria-hidden="true"
        />
        <span>{t("微信登录")}</span>
      </button>
    </div>
  );
}
